module.exports = __webpack_public_path__ + "static/backto-desktop-beac6ab578c7e0b954219e06b7160304.svg";